import { CommonModule } from '@angular/common';
import { Directive, ElementRef, HostBinding, Input, NgModule } from '@angular/core';

@Directive({
	standalone: false,
	selector: '[navigationElement]',
	exportAs: 'navigationElement',
	host: {
		class: '__reach-navigation-element',
	},
})
export class PhoneNavigationElementDirective<T> {
	@Input()
	public navigationElement: T;

	@Input()
	public activeClass = '__reach-navigation-element-active';

	private active = false;

	public get id(): T {
		return this.navigationElement;
	}

	@HostBinding('class')
	public get currentClass(): string {
		return this.active ? this.activeClass : '';
	}

	constructor(private elementRef: ElementRef<HTMLElement>) {}

	public get nativeElement(): HTMLElement {
		return this.elementRef.nativeElement;
	}

	public setAsActive(): void {
		this.active = true;
	}

	public setAsInactive(): void {
		this.active = false;
	}
}

@NgModule({
	declarations: [PhoneNavigationElementDirective],
	imports: [CommonModule],
	exports: [PhoneNavigationElementDirective],
})
export class NavigationSharedModule {}
